// src/utils/track.js
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

const SESSION_KEY = 'analytics_session_id';

// Types die we ook zonder login versturen, via het publieke endpoint. Moet
// overeenkomen met ANONYMOUS_ALLOWED_TYPES in de backend-controller.
const ANONYMOUS_TYPES = new Set(['pdf_download', 'pageview']);

/**
 * Id per bezoek: sessionStorage, dus weg als het tabblad sluit en een nieuw
 * tabblad krijgt een nieuwe. Zo zijn anonieme events binnen een bezoek aan
 * elkaar te koppelen zonder een bezoeker over bezoeken heen te volgen. Valt
 * stil terug op null als storage niet beschikbaar is (geblokkeerde cookies).
 */
function getSessionId() {
  try {
    localStorage.removeItem(SESSION_KEY);
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Minimale tracker: stuurt pageviews/events naar Strapi.
 * Ingelogde gebruikers gaan naar het gewone endpoint en worden aan hun account
 * gekoppeld; van de types in ANONYMOUS_TYPES loggen we ook bezoekers zonder
 * account, via het publieke endpoint.
 */
export async function trackEvent({ type, path, title, payload, sessionId }) {
  try {
    let jwt = null;
    try {
      jwt = localStorage.getItem('jwt');
    } catch {
      // storage geblokkeerd: behandel als anonieme bezoeker
    }
    if (!jwt && !ANONYMOUS_TYPES.has(type)) return;

    const endpoint = jwt
      ? `${STRAPI_URL}/api/analytics-events`
      : `${STRAPI_URL}/api/analytics-events/public`;

    await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
      },
      body: JSON.stringify({
        data: { type, path, title, payload, sessionId: sessionId ?? getSessionId() },
      }),
    });
  } catch {
    // bewust stil falen
  }
}
